import React from 'react';
import { connect } from 'react-redux';

import { createComponent, Layout, Header, Button, Label, enums, Media } from 'console-kit';
import authStatics from '../../../common/static';

import WelcomePanelActions from '../redux/actions';
import AuthImageLogo from '../../../components/AuthImageLogo';

const WelcomePanel = createComponent({
  displayName: 'WelcomePanel',
  handlers:    {
    handleClick:
      (p) =>
        (e, { value }) => {
          p.onWelcomeRedirectRequestClicked();
          window.location.href = '/admin/dashboard/index';
        },
  },
  render(props) {
    return (
      <div className={authStatics.SCREEN_CLASSES_WIDE}>
        <Layout isFluidHeight>
          <Layout.Row>
            <Layout.Column textAlign={enums.textAlignments.CENTER}>
              <AuthImageLogo />
            </Layout.Column>
          </Layout.Row>

          <Layout.Row>
            <Layout.Column textAlign={enums.textAlignments.LEFT}>
              <Header
                text="Welcome!"
                isDividing={false}
                font={{
                  emphasis: enums.font.emphasis.NORMAL,
                }}
                size={enums.sizes.X6}
              />
            </Layout.Column>
          </Layout.Row>

          <Layout.Row>
            <Layout.Column textAlign={enums.textAlignments.LEFT}>
              <Label
                text="Before you get started, we want to take just a couple minutes of your time to introduce you to the key areas of Marigold Grow. If you've already had your training session, this will be a great reminder of how you can access training videos, articles and how you can get help from the Support Team, if you ever need it."
                hasPadding={false}
                display={enums.display.PLAIN}
                size={enums.sizes.X4}
                isFluid
              />
            </Layout.Column>
          </Layout.Row>

          <Layout.Row>
            <Layout.Column textAlign={enums.textAlignments.CENTER}>
              <Media reference={'vimeo:video:auto:https://vimeo.com/949571443/11277304'} isCircular={false} />
            </Layout.Column>
          </Layout.Row>

          <Layout.Row>
            <Button.WithAnimation
              actions={{
                start:   WelcomePanelActions.onWelcomeRedirectRequest,
                success: WelcomePanelActions.onWelcomeRedirectSuccess, //no action
                failure: WelcomePanelActions.onWelcomeRedirectFailure, //no action
              }}
            >
              <Button.Primary
                text="Let's go"
                float={enums.positions.RIGHT}
                size={enums.sizes.X4}
                onClick={props.handleClick}
                textAlign={enums.textAlignments.CENTER}
                color={enums.colors.ACCENT}
                isSolid
                isFluid
                isDisabled={false}
              />
            </Button.WithAnimation>
          </Layout.Row>
        </Layout>
      </div>
    );
  },
});

export default connect(null, (dispatch) => ({
  onWelcomeRedirectRequestClicked() {
    dispatch(WelcomePanelActions.onWelcomeRedirectRequest());
  },
}))(WelcomePanel);
